var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"header-content"},[_c('h1',[_vm._v("Where in the world?")]),_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }